<template>
  <v-app>
    <v-navigation-drawer
      v-if="$router.currentRoute.name !== 'Landing'"
      v-model="drawer"
      color="primary"
      app
    >
      <v-list>
        <v-list-item two-line link :to="{ name: 'Home' }">
          <v-list-item-avatar color="white">
            <span class="primary--text headline">
              {{ $store.getters['account/name'].charAt(0) }}
            </span>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              $store.state.account.profile.name
            }}</v-list-item-title>
            <v-list-item-subtitle class="white--text">
              {{ $store.state.account.role }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-for="item in item1" :key="item.title" :to="item.to">
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              item.text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="white"></v-divider>
        <v-list-item v-for="item in item2" :key="item.title" link :to="item.to">
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              item.text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block outlined class="white primary--text" @click="logout">
            {{ $t('btn_msg_logout') }}
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar app color="white" flat height="80">
      <v-app-bar-nav-icon
        v-show="$router.currentRoute.name !== 'Landing'"
        @click.stop="drawer = !drawer"
      />
      <router-link :to="{ name: 'Home' }">
        <v-img
          alt="Casstack"
          class="shrink mr-2"
          contain
          src="casstack-logo-header.svg"
          transition="scale-transition"
          :width="
            $vuetify.breakpoint.xsOnly
              ? 100
              : $vuetify.breakpoint.smOnly
              ? 180
              : 200
          "
        />
      </router-link>

      <v-spacer></v-spacer>

      <v-btn
        rounded
        :large="$vuetify.breakpoint.mdAndUp"
        :elevation="$vuetify.breakpoint.mdAndUp ? 5 : 0"
        class="primary white--text"
        href="https://m.me/casstackcompany"
        target="_blank"
      >
        <v-icon class="px-1 px-md-2"> mdi-comment-question </v-icon>
        <span class="pr-md-2 pr-1">
          {{ $t('btn_txt_support') }}
        </span>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            :large="$vuetify.breakpoint.mdAndUp"
            :elevation="$vuetify.breakpoint.mdAndUp ? 5 : 0"
            icon
            class="mx-1 primary white--color"
            v-on="on"
          >
            <v-img
              alt="Casstack"
              class="shrink"
              contain
              :src="locale.icon"
              transition="scale-transition"
              sizes="28"
            />
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in locales"
            :key="index"
            @click="$i18n.locale = item.locale"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container v-show="!$store.state.appLoading" fluid class="ma-0 pa-0">
        <router-view :locale="locale.locale"></router-view>
      </v-container>
      <v-container v-show="$store.state.appLoading" fluid class="ma-0 pa-0">
        <v-row justify="center" align="center">
          <v-col cols="10" md="6">
            <div class="text-center">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <span class="font-weight-medium primary--text">
                {{ $t('cap_msg_waiting') }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { languages } from './plugins/i18n'
export default {
  name: 'App',
  data() {
    return {
      drawer: true
    }
  },
  computed: {
    item1() {
      return [
        {
          icon: 'mdi-cart',
          text: this.$t('btn_txt_orders'),
          to: { name: 'Order' }
        },
        {
          icon: 'mdi-dropbox',
          text: this.$t('btn_txt_product'),
          to: { name: 'Product' }
        },
        {
          icon: 'mdi-account-multiple',
          text: this.$t('btn_txt_employee'),
          to: { name: 'Employee' }
        }
      ]
    },
    item2() {
      return [
        {
          icon: 'mdi-credit-card',
          text: this.$t('btn_txt_payment'),
          to: { name: 'Payment' }
        },
        {
          icon: 'mdi-brightness-5',
          text: this.$t('btn_txt_setting'),
          to: { name: 'Setting' }
        }
      ]
    },
    locales() {
      return languages
    },
    locale() {
      const lang = languages.find((x) => x.locale === this.$i18n.locale)
      if (lang) {
        return lang
      }
      return languages.find((x) => x.locale === 'en')
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('account/logout')
    }
  }
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
